import { computed } from '@vue/composition-api';
import { Message, MessageType } from '../dataType';
import { useMessage } from './useMessage';

// 不属于交互的消息类型
const notInteractType: MessageType[] = ['ai.sendText', 'ai.waiting', 'custom', 'ai.noneData', 'ai.intentionBack'];

export const useMessageInteract = (message: Message<any>) => {
  const { nextMessage } = useMessage();
  return {
    // 是否可操作
    isDisabled: computed<boolean>(() => {
      // 消息记录的不可操作
      if (message.isRecord) {
        return true;
      }
      // 如果下面的卡片有可交互的消息，那么当前消息不可交互
      const msg = nextMessage(message.id, (nextMessage) => !notInteractType.includes(nextMessage.type));
      return !!msg;
    })
  };
};
